module.exports = __webpack_public_path__ + "img/open-tables.3865c03a.png";